// This component handles the App template used on every page.
import React from "react";
import { connect } from "react-redux";
import SideMenu from "./side-menu/sideMenu";
import MenuToggle from "./common/menuToggle";
import Util from "../util/util";
import Messages from "../configurations/messages";

const TIMEOUT_DURATION = 900000;
class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      sideMenu: false,
      redirect: false,
    };
    this.toggleSideMenu = this.toggleSideMenu.bind(this);
    this.timeout = null;
    this.resetTimeout = this.resetTimeout.bind(this);
  }

  componentDidMount() {
    this.resetTimer();
  }

  componentWillUnmount() {
    this.clearTimer();
    this.removeEventListeners();
  }

  resetTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.setState({ redirect: true });
    }, TIMEOUT_DURATION);
  }

  resetTimer() {
    this.resetTimeout();
    window.addEventListener("click", this.resetTimeout);
    window.addEventListener("mousemove", this.resetTimeout);
    window.addEventListener("keypress", this.resetTimeout);
    window.addEventListener("scroll", this.resetTimeout);
  }

  clearTimer() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  removeEventListeners() {
    window.removeEventListener("click", this.resetTimeout);
    window.removeEventListener("mousemove", this.resetTimeout);
    window.removeEventListener("keypress", this.resetTimeout);
    window.removeEventListener("scroll", this.resetTimeout);
  }

  toggleSideMenu() {
    this.setState({ sideMenu: !this.state.sideMenu });
  }

  render() {
    const { redirect } = this.state;
    const currentUrl = window.location.href;
    if (redirect && process.env.NODE_ENV === "production") {
      window.location.href = currentUrl.includes("k8")
        ? "https://passport-v2.k8.isw.la/passport/login"
        : "https://passport.interswitchng.com/passport/login";
    }
    return (
      <div>
        {this.props.userPermissions &&
          this.props.userPermissions.length === 0 && (
            <div className="no-permissions">
              <div>
                <i className="ion ion-alert-circled large-error-icon" />
                <br />
                {Messages.NO_PERMISSIONS}
              </div>
            </div>
          )}
        {this.props.userPermissions &&
          this.props.userPermissions.length > 0 && (
            <div>
              <MenuToggle
                className="menu-toggle"
                onClick={this.toggleSideMenu}
              />
              <div className="lower-layout">
                <div
                  className={`${
                    this.state.sideMenu ? "" : "hide-menu"
                  } sidebar col-md-2 col-sm-2`}
                >
                  <SideMenu location={this.props.location} />
                </div>
                <div
                  className="main-content col-md-10 col-sm-12 col-md-push-2"
                  onClick={(evt) => {
                    if (this.state.sideMenu) this.toggleSideMenu();
                  }}
                >
                  <div className="body-content col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="app-content">{this.props.children}</div>
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js